import React, { useEffect, useState } from "react";
import { FiLoader } from "react-icons/fi";
import { apiFetch } from "../utils/apiFetch";
import { Link } from "react-router";

export default function GroupPricingFields({ value, onChange, disabled }) {
  const [options, setOptions] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    const controller = new AbortController();
    apiFetch(`${process.env.API_URL}/api/group-purchases/options`, { signal: controller.signal })
      .then(async response => { const data = await response.json(); if (!response.ok) throw Error(data.message); setOptions(data); })
      .catch(error => { if (!controller.signal.aborted) setError(error.message || "Could not load payment options"); });
    return () => controller.abort();
  }, []);
  return <fieldset disabled={disabled} className="space-y-4">
    <legend className="mb-2 text-sm font-semibold">Group access</legend>
    <div className="flex gap-6">
      {["free", "paid"].map(access => <label key={access} className="flex items-center gap-2 text-sm font-medium capitalize">
        <input type="radio" name="group-access" value={access} checked={value.access === access} onChange={() => onChange({ ...value, access })} className="accent-orange-700" />{access}
      </label>)}
    </div>
    {value.access === "paid" && <>
      {!options && !error && <FiLoader aria-label="Loading payment options" className="animate-spin" />}
      {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
      {options && !options.payoutReady && <Link to="/owner-payouts" className="inline-block text-sm font-semibold text-orange-800 underline">Set up owner payouts</Link>}
      {options?.payoutMode === "manual" && <Link to="/owner-payouts" className="inline-block text-sm font-semibold text-orange-800 underline">Add or update your payout bank account</Link>}
      <div className="grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-3">
        <label className="space-y-2 text-sm font-medium"><span>Currency</span>
          <select aria-label="Currency" value={value.currency} onChange={event => onChange({ ...value, currency: event.target.value })} className="h-10 w-full rounded-md border border-gray-300 bg-white px-3">
            {(options?.currencies || [{ code: "INR" }]).map(item => <option key={item.code} value={item.code}>{item.code}</option>)}
          </select>
        </label>
        <label className="space-y-2 text-sm font-medium"><span>Monthly price</span>
          <input aria-label="Monthly price" type="number" inputMode="decimal" min="1" step="0.01" required value={value.amount} onChange={event => onChange({ ...value, amount: event.target.value })} className="h-10 w-full rounded-md border border-gray-300 bg-white px-3" />
        </label>
      </div>
    </>}
  </fieldset>;
}
